import React from "react";
import {animationData} from '../component/SplashScreen/animationData';
import Lottie from 'react-lottie';
import {withRouter} from "react-router-dom";

// lotti file option
const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: animationData,
    rendererSettings: {
        preserveAspectRatio: 'xMidYMid slice'
    }

};

class Home extends React.Component{

    componentDidMount() {
        let scope = this;
        setTimeout(() => {
            scope.props.history.push("/home");
        }, 3000)
    }


    render() {
        return(
            <div>
                <Lottie options={defaultOptions} width={"100%"} height={"100%"}/>
            </div>
        );
    }
}

export default withRouter(Home);
